<ng-container class="ms-2 me-2">

    <ng-container *ngIf="spinner">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>

    <ng-container *ngIf="spinner != true">
        <div class="butonera">
            <select [(ngModel)]="trimester" (selectionChange)="change()" class="form-select me-1">
                <option>Seleccionar trimestre</option>
                <option value="1">Primer trimestre</option>
                <option value="2">Segundo trimestre</option>
                <option value="3">Tercer trimestre</option>
                <option value="4">Cuatro trimestre</option>
                <option value="5">Anual</option>
            </select>
            <button mat-stroked-button class="ms-2" (click)="go()">Generar listado</button>
            <button mat-stroked-button class="ms-2" (click)="export()">Generar Excel</button>
        </div>
        <app-table
          [columns]="headerTable"
          [dataSource]="irpfList"
          [hasButton]="true"
          [actionsTemplate]="actionsButtons"
          [showTotals]="true" [showTotalsHasOptionToPay]="false"
          [textPaided]="'Cobrado'" [textUnpaid]="'No cobrado'"
          [hasSelect]="true"
          >
        </app-table>

        <!-- Acciones -->
        <ng-template #actionsButtons let-uid="uid">
          <ng-container *ngFor="let row of (irpfList | filter : uid : 'uid'); trackBy: trackByIndex">
            <ul class="custom-class">
              <ng-container *ngIf="row.pdf === true">
                  <li (click)="downloadFilePdf(row.invoiceUid)">
                    <a>
                        <mat-icon>attachment</mat-icon> Documento
                    </a>
                  </li>
              </ng-container>
              <ng-container *ngIf="row.image === true">
                <li (click)="downloadFileImage(row.invoiceUid)">
                  <a>
                      <mat-icon>image</mat-icon> Documento
                  </a>
                </li>
            </ng-container>
              <ng-container *ngIf="row.pdf === false && row.image === false">
                <li>
                  No tiene archivos adjuntos
                </li>
            </ng-container>
            </ul>
          </ng-container>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="empty" class="ms-2 me-2">
        <br />
        <p class="ms-4 fc-black">No dispone de facturas emitidas con IRPF en el trimestre seleccionado.</p>
    </ng-container>

</ng-container>
